var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueGcik(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 17,
    viewBox: "0 0 100 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23584 8.44506C2.23584 8.44506 7.58659 0.0495357 13.7433 8.44506C19.9 16.8406 25.7657 8.44506 25.7657 8.44506C25.7657 8.44506 31.8851 0.0495357 38.0567 8.44506C44.2284 16.8406 49.3254 8.44506 49.3254 8.44506C49.3254 8.44506 54.6463 0.0495357 60.803 8.44506C66.9597 16.8406 74.2358 8.44506 74.2358 8.44506C74.2358 8.44506 80.3403 0.0495357 86.497 8.44506C92.6537 16.8406 97.7582 8.44506 97.7582 8.44506",
    stroke: "#3D90F4",
    strokeWidth: 3.73134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 16,
    fill: "white",
    transform: "translate(-0.00292969 0.445068)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueGcik);
export default __webpack_public_path__ + "static/media/blueGcik.7db075d43807f48d1e9c2d4c3cc70150.svg";
export { ForwardRef as ReactComponent };